
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35190',
  depVersions: {
  "documents-public-ui": "static-1.35190",
  "atom": "static-1.5367",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2766",
  "client-types": "static-1.496",
  "cssUtils": "static-1.902",
  "customer-data-filters-ui": "static-1.40865",
  "customer-data-objects": "static-1.7972",
  "customer-data-property-utils": "static-1.8384",
  "documents-lib": "static-1.35195",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.366",
  "FormsCommonComponents": "static-1.86526",
  "FormUrlGenerator": "static-2.5009",
  "foundations-theming-specialty": "static-1.2470",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.109",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5878",
  "hs-test-utils": "static-1.8314",
  "hub-http": "static-1.6494",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12075",
  "HubStyleTokens": "static-2.11768",
  "I18n": "static-7.1669",
  "icons": "static-2.678",
  "jasmine-immutable": "static-1.3303",
  "jasmine-runner": "static-1.6734",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7431",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3176",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5679",
  "quartz": "static-1.7433",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16998",
  "react-select-plus": "static-1.110",
  "react-utils": "static-2.5542",
  "react-virtualized": "static-2.105",
  "reference-resolvers": "static-1.8463",
  "reference-resolvers-lite": "static-1.8383",
  "reporting-data": "static-1.68752",
  "reporting-reports": "static-1.68429",
  "reporting-snowflake": "static-1.57369",
  "reporting-testing-lib": "static-1.10685",
  "reporting-visualizations": "static-1.60827",
  "reselect": "static-3.10",
  "sales-content-partitioning": "static-1.9233",
  "sanitize": "static-1.4755",
  "sanitize-text": "static-1.8435",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2028",
  "signup-constants": "static-1.19595",
  "signup-ui-url-generator": "static-2.8343",
  "StyleGuideUI": "static-3.501",
  "superstore": "static-1.5038",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5040",
  "ui-addon-form-validation": "static-1.11264",
  "ui-asset-management-lib": "static-1.11379",
  "ui-images": "static-2.1239",
  "UIComponents": "static-3.8714",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7357",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9937",
  "foundations-components": "static-1-ech-accordiontransition-jank.30",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1211",
  "quartz-core": "static-1.6652",
  "quick-fetch": "static-1.4117",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.78",
  "rpc-client-utils": "static-1.4947",
  "ui-addon-i18n": "static-1.11428",
  "ui-addon-upgrades": "static-9.18356",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3606",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3710",
  "quartz-webpack": "static-1.3657",
  "foundations-assets": "static-1.5165",
  "foundations-theming": "static-1.4754",
  "hub-http-janus": "static-1.875",
  "hub-http-shared-msw-handlers": "static-1.10586",
  "hubspotter-http": "static-1.4850",
  "sassPrefix": "static-1.174",
  "conversations-skeleton-state": "static-1.7527",
  "crm-message-bus": "static-1.43722",
  "customer-data-filters-ui-msw-helpers": "static-1.23300",
  "customer-data-objects-ui-components": "static-1.13313",
  "customer-data-reference-ui-components": "static-1.13460",
  "customer-data-ui-utilities": "static-1.10109",
  "events-data-lib": "static-1.525",
  "framework-builder-read-service-client": "static-1.4207",
  "hs-resources": "static-1.473",
  "immer": "static-1.99",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4042",
  "multi-account-reference-resolvers": "static-1.1284",
  "onboarding-scopes": "static-1.6735",
  "onboarding-tours": "static-1.17090",
  "pulse": "static-1.910",
  "reporting-datasets-permissions-lib": "static-1.14432",
  "stylex": "static-1.39",
  "trellis-assets": "static-1.2588",
  "trellis-components": "static-1.2607",
  "trellis-theming": "static-1.1256",
  "ui-addon-teams": "static-1.21888",
  "quartz-auth": "static-1.1108",
  "ui-business-units-lib": "static-1.9369",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9675",
  "ContentUtils": "static-1.69091",
  "customer-data-properties": "static-1.52529",
  "forms-ai-lib": "static-1.4738",
  "forms-utils-lib": "static-1.13069",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.30",
  "react-dnd-compat": "static-1.4899",
  "react-tinymce": "static-1.55943",
  "tinymce-config": "static-2.55069",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3739",
  "HeadJS": "static-2.794",
  "framer-motion": "static-1.77",
  "hs-test-utils-bend-plugin": "static-1.3425",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "hs-locale-management": "static-1.279",
  "ui-fonts": "static-1.1030",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4595",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1098",
  "web-vitals": "static-1.13",
  "batch-promise": "static-1.1824",
  "external-options-client-types": "static-1.4325",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7174",
  "quartz-i18n": "static-1.1108",
  "frontend-preferences-client": "static-1.8204",
  "graphql": "static-1.87",
  "persist-promise": "static-1.3981",
  "reporting-client-types": "static-1.2673",
  "apollo-stack-hubspot": "static-3.92",
  "growth-payments-core": "static-1.26145",
  "hubspot-apollo-client": "static-1.5159",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.30",
  "quartz-routing": "static-1.863",
  "hs-story-utils": "static-1.9707",
  "react-flip-move": "static-1.76",
  "nested-table": "static-1.516",
  "seat-types-lib": "static-1.681",
  "timezone-utils": "static-2.5527",
  "react-create-root-preference": "static-1.68",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.30",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.71",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.50",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.425",
  "quartz-test": "static-1.1108",
  "quartz-tracking": "static-1.812",
  "bend-plugin-chirp-manifest": "static-1.357",
  "chirp-fetch": "static-1.2176",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6339",
  "salesImages": "static-1.545",
  "ts-schema": "static-1.4279",
  "bender-build-tools": "static-1.3425",
  "bend-plugin-foundations-theming": "static-1.3237",
  "restore-request-side-panel-lib": "static-1.1633",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4937",
  "conditional-properties-service-client": "static-1.3998",
  "crm-pipelines-api-client-types": "static-1.4333",
  "event-emitter": "static-1.1234",
  "fdsr-migration-layer": "static-1.293",
  "multi-currency-client-types": "static-1.3894",
  "getting-started-shared-tasks": "static-1.19201",
  "growth-data-modal": "static-1.5867",
  "growth-onboarding-confetti": "static-1.3342",
  "growth-onboarding-next-action-utils": "static-1.2655",
  "navigation-components": "static-1.18794",
  "onboarding-tours-client": "static-1.5305",
  "onboarding-tours-utils": "static-1.1157",
  "ui-shepherd-react": "static-3.10550",
  "ui-shepherd-tracker": "static-1.7931",
  "ui-universal-auth": "static-1.9370",
  "user-context": "static-1.5401",
  "bend-plugin-pulse": "static-1.413",
  "fast-json-patch": "static-1.68",
  "stylex-utils": "static-1.138",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10584",
  "magpie-lib": "static-1.5740",
  "navigation-messaging": "static-1.8121",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22914",
  "copilot-toolkit": "static-1.11821",
  "cms-field-types": "static-1.5096",
  "content-icons-ui": "static-1.2345",
  "integrations-lib": "static-1.16993",
  "calling-global-api": "static-1.65553",
  "calling-internal-common": "static-1.31599",
  "calling-lifecycle-internal": "static-1.66935",
  "calling-lifecycle-messages": "static-1.59229",
  "commerce-products-lib": "static-1.10495",
  "crm-index-visualization-core": "static-1.4520",
  "crm-links": "static-1.6611",
  "customer-data-properties-shared-msw-handlers": "static-1.9913",
  "file-manager-components": "static-1.24446",
  "formula-editor": "static-1.14727",
  "google-libphonenumber": "static-1.43",
  "inbounddb-objects-service-types": "static-1.4412",
  "meetings-icalendar-utils-lib": "static-1.916",
  "object-builder-ui-client": "static-1.49630",
  "pipeline-validation-client-types": "static-1.4167",
  "property-value-citations": "static-1.3143",
  "smart-data-capture-core": "static-1.106",
  "smart-property-lib": "static-1.8251",
  "tiered-pricing": "static-1.1926",
  "topics-actions-lib": "static-1.446",
  "trial-components-library": "static-1.14080",
  "ui-addon-iframeable": "static-1.9359",
  "zustand": "static-1.83",
  "final-form": "static-1.76",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.76",
  "rich-text-lib": "static-1.20279",
  "tinymce-themes": "static-1.57039",
  "data-token-picker": "static-1.16861",
  "hub-http-contrib": "static-1.3320",
  "interframe": "static-3.5037",
  "tinymce-data": "static-1.41154",
  "tinymce-plugins": "static-1.58183",
  "ui-addon-sales-email": "static-1.5494",
  "framework-data-schema-quick-fetch": "static-1.7079",
  "ui-addon-opt": "static-4.8645",
  "hubspot-apollo-cache": "static-1.618",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.431",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6342",
  "onboarding-data-sync-lib": "static-1.2482",
  "growth-onboarding-next-action-components": "static-1.2683",
  "user-context-client": "static-1.4789",
  "idb-keyval": "static-1.49",
  "magpie-types": "static-1.5200",
  "nest": "static-1.517",
  "reactive-lib": "static-1.1001",
  "simple-logging-lib": "static-1.3332",
  "unified-auth-core-lib": "static-1.1166",
  "getting-started-shared-tasks-store": "static-1.18319",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1683",
  "integrations-error-boundary-lib": "static-1.14408",
  "integrations-tracking-lib": "static-1.5890",
  "native-integrations-shared-strings": "static-1.8059",
  "redux-observable": "static-1.73",
  "ReduxMessenger": "static-2.10651",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.884",
  "calling-error-reporting": "static-1.31606",
  "shared-worker-versioning": "static-1.11322",
  "calling-usage-tracker": "static-1.6818",
  "voice-sms-access-library": "static-1.1990",
  "customer-data-tracking": "static-1.7163",
  "commerce-permissions": "static-1.1059",
  "products-iframe-lib": "static-1.8557",
  "products-ui-components-shared-msw-handlers": "static-1.10968",
  "crm-index-associations-lib": "static-1.6723",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10669",
  "sales-views-client-types": "static-1.4537",
  "location-customization-utils-lib": "static-1.10063",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4431",
  "video-components-external": "static-1.12121",
  "video-data-lib": "static-1.35779",
  "bark-lib": "static-1.16793",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.100",
  "crm-properties-common-lib": "static-1.6171",
  "react-codemirror": "static-1.10920",
  "data-agent-kit": "static-1.622",
  "feedback-loader": "static-1.29782",
  "fsm": "static-1.4031",
  "policy-lib": "static-1.7083",
  "react-colorpicker": "static-2.10497",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10732",
  "embedded-academy-lib": "static-1.15474",
  "hubs-service-types": "static-1.1538",
  "FileManagerLib": "static-1.40086",
  "NamespacedHubStyle": "static-2.9249",
  "FileManagerCore": "static-1.39945",
  "content-assistance-lib": "static-1.8175",
  "layout-dnd-components": "static-1.12939",
  "layout-dnd-utils": "static-1.11914",
  "ui-addon-emoji-picker": "static-1.10167",
  "ui-brand-identity-lib": "static-1.16412",
  "InboxConnectUtils": "static-4.15525",
  "meetings-connect-utils-lib": "static-1.7890",
  "breeze-engine-chat-components": "static-1.661",
  "breeze-engine-core": "static-1.961",
  "ably": "static-2.2",
  "highlight.js": "static-1.84",
  "universal-page-editor-lib": "static-1.3289",
  "adobe-sign-auth-lib": "static-1.429",
  "ads-unified-auth-lib": "static-1.1260",
  "google-sheets-integration-lib": "static-1.995",
  "microsoft-drive-auth-lib": "static-1.104",
  "surveymonkey-integration-lib": "static-1.438",
  "slack-ui-library": "static-1.10681",
  "calling-orchestration-schema": "static-1.36767",
  "crm-record-cards-service-types": "static-1.3772",
  "content-media-composition-data-lib": "static-1.13198",
  "content-media-compositions": "static-2.17205",
  "media-bridge-lib": "static-1.19381",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16331",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4790",
  "storybook-react": "static-1.38",
  "academy-common-lib": "static-1.14934",
  "audio-components": "static-1.6317",
  "FileManagerImages": "static-1.37597",
  "video-components": "static-1.14123",
  "breeze-artifacts-sdk": "static-1.277",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.59",
  "urlinator": "static-1.4814",
  "video-embed": "static-1.36613",
  "ui-addon-video-player": "static-1.8984",
  "ui-coaching-tips": "static-1.29272",
  "ContentData": "static-1.69166",
  "layout-data-lib": "static-1.10239",
  "academy-service-client": "static-1.3968",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4684",
  "trellis-ecosystem": "static-1.7603",
  "ui-addon-react-router-dom": "static-1.9819",
  "wootric-nps": "static-1.7186",
  "social-insights-client-types": "static-1.22704",
  "outpost": "static-1.4438",
  "growth-onboarding-feedback-components": "static-1.6866",
  "advanced-menus-core": "static-1.15551",
  "advanced-menus-lib": "static-1.12427",
  "ExportDialog": "static-6.10659",
  "ui-memberships-settings-lib": "static-1.34808",
  "marketplace-ui-apps-core": "static-1.19225",
  "marketplace-ui-common": "static-1.20693",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15550",
  "simple-menus-lib": "static-1.17067",
  "developer-experience-shared-components": "static-1.10786",
  "immutable-less": "static-1.4931",
  "marketplace-ui-client-types": "static-1.18100",
  "ui-addon-integrations-directory-panel": "static-2.8306",
  "ui-extensibility-client-types": "static-1.4199",
  "ai-settings-ui-library": "static-1.8303",
  "nav-meta": "static-1.30431",
  "ui-product-approvals-common": "static-1.994",
  "apps-service-types": "static-1.4021",
  "oauth-service-types": "static-1.4518",
  "simple-data-table": "static-1.3501"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35190",
  "atom": "/atom/static-1.5367",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2766",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.902",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40865",
  "customer-data-objects": "/customer-data-objects/static-1.7972",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8384",
  "documents-lib": "/documents-lib/static-1.35195",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.366",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86526",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5009",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2470",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.109",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5878",
  "hs-test-utils": "/hs-test-utils/static-1.8314",
  "hub-http": "/hub-http/static-1.6494",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12075",
  "HubStyleTokens": "/HubStyleTokens/static-2.11768",
  "I18n": "/I18n/static-7.1669",
  "icons": "/icons/static-2.678",
  "jasmine-immutable": "/jasmine-immutable/static-1.3303",
  "jasmine-runner": "/jasmine-runner/static-1.6734",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7431",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3176",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5679",
  "quartz": "/quartz/static-1.7433",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16998",
  "react-select-plus": "/react-select-plus/static-1.110",
  "react-utils": "/react-utils/static-2.5542",
  "react-virtualized": "/react-virtualized/static-2.105",
  "reference-resolvers": "/reference-resolvers/static-1.8463",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8383",
  "reporting-data": "/reporting-data/static-1.68752",
  "reporting-reports": "/reporting-reports/static-1.68429",
  "reporting-snowflake": "/reporting-snowflake/static-1.57369",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10685",
  "reporting-visualizations": "/reporting-visualizations/static-1.60827",
  "reselect": "/reselect/static-3.10",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9233",
  "sanitize": "/sanitize/static-1.4755",
  "sanitize-text": "/sanitize-text/static-1.8435",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2028",
  "signup-constants": "/signup-constants/static-1.19595",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8343",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "superstore": "/superstore/static-1.5038",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5040",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11264",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11379",
  "ui-images": "/ui-images/static-2.1239",
  "UIComponents": "/UIComponents/static-3.8714",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7357",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9937",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.30",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1211",
  "quartz-core": "/quartz-core/static-1.6652",
  "quick-fetch": "/quick-fetch/static-1.4117",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.78",
  "rpc-client-utils": "/rpc-client-utils/static-1.4947",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11428",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18356",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3606",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3710",
  "quartz-webpack": "/quartz-webpack/static-1.3657",
  "foundations-assets": "/foundations-assets/static-1.5165",
  "foundations-theming": "/foundations-theming/static-1.4754",
  "hub-http-janus": "/hub-http-janus/static-1.875",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10586",
  "hubspotter-http": "/hubspotter-http/static-1.4850",
  "sassPrefix": "/sassPrefix/static-1.174",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7527",
  "crm-message-bus": "/crm-message-bus/static-1.43722",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23300",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13313",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13460",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10109",
  "events-data-lib": "/events-data-lib/static-1.525",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4207",
  "hs-resources": "/hs-resources/static-1.473",
  "immer": "/immer/static-1.99",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4042",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1284",
  "onboarding-scopes": "/onboarding-scopes/static-1.6735",
  "onboarding-tours": "/onboarding-tours/static-1.17090",
  "pulse": "/pulse/static-1.910",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14432",
  "stylex": "/stylex/static-1.39",
  "trellis-assets": "/trellis-assets/static-1.2588",
  "trellis-components": "/trellis-components/static-1.2607",
  "trellis-theming": "/trellis-theming/static-1.1256",
  "ui-addon-teams": "/ui-addon-teams/static-1.21888",
  "quartz-auth": "/quartz-auth/static-1.1108",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9369",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9675",
  "ContentUtils": "/ContentUtils/static-1.69091",
  "customer-data-properties": "/customer-data-properties/static-1.52529",
  "forms-ai-lib": "/forms-ai-lib/static-1.4738",
  "forms-utils-lib": "/forms-utils-lib/static-1.13069",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.30",
  "react-dnd-compat": "/react-dnd-compat/static-1.4899",
  "react-tinymce": "/react-tinymce/static-1.55943",
  "tinymce-config": "/tinymce-config/static-2.55069",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3739",
  "HeadJS": "/HeadJS/static-2.794",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3425",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "hs-locale-management": "/hs-locale-management/static-1.279",
  "ui-fonts": "/ui-fonts/static-1.1030",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4595",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1098",
  "web-vitals": "/web-vitals/static-1.13",
  "batch-promise": "/batch-promise/static-1.1824",
  "external-options-client-types": "/external-options-client-types/static-1.4325",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7174",
  "quartz-i18n": "/quartz-i18n/static-1.1108",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8204",
  "graphql": "/graphql/static-1.87",
  "persist-promise": "/persist-promise/static-1.3981",
  "reporting-client-types": "/reporting-client-types/static-1.2673",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.92",
  "growth-payments-core": "/growth-payments-core/static-1.26145",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5159",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.30",
  "quartz-routing": "/quartz-routing/static-1.863",
  "hs-story-utils": "/hs-story-utils/static-1.9707",
  "react-flip-move": "/react-flip-move/static-1.76",
  "nested-table": "/nested-table/static-1.516",
  "seat-types-lib": "/seat-types-lib/static-1.681",
  "timezone-utils": "/timezone-utils/static-2.5527",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.30",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.71",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.50",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.425",
  "quartz-test": "/quartz-test/static-1.1108",
  "quartz-tracking": "/quartz-tracking/static-1.812",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.357",
  "chirp-fetch": "/chirp-fetch/static-1.2176",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6339",
  "salesImages": "/salesImages/static-1.545",
  "ts-schema": "/ts-schema/static-1.4279",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3237",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1633",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4937",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3998",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4333",
  "event-emitter": "/event-emitter/static-1.1234",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.293",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3894",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19201",
  "growth-data-modal": "/growth-data-modal/static-1.5867",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3342",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2655",
  "navigation-components": "/navigation-components/static-1.18794",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5305",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1157",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10550",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7931",
  "ui-universal-auth": "/ui-universal-auth/static-1.9370",
  "user-context": "/user-context/static-1.5401",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.413",
  "fast-json-patch": "/fast-json-patch/static-1.68",
  "stylex-utils": "/stylex-utils/static-1.138",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10584",
  "magpie-lib": "/magpie-lib/static-1.5740",
  "navigation-messaging": "/navigation-messaging/static-1.8121",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22914",
  "copilot-toolkit": "/copilot-toolkit/static-1.11821",
  "cms-field-types": "/cms-field-types/static-1.5096",
  "content-icons-ui": "/content-icons-ui/static-1.2345",
  "integrations-lib": "/integrations-lib/static-1.16993",
  "calling-global-api": "/calling-global-api/static-1.65553",
  "calling-internal-common": "/calling-internal-common/static-1.31599",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66935",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59229",
  "commerce-products-lib": "/commerce-products-lib/static-1.10495",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4520",
  "crm-links": "/crm-links/static-1.6611",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9913",
  "file-manager-components": "/file-manager-components/static-1.24446",
  "formula-editor": "/formula-editor/static-1.14727",
  "google-libphonenumber": "/google-libphonenumber/static-1.43",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4412",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.916",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49630",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4167",
  "property-value-citations": "/property-value-citations/static-1.3143",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.106",
  "smart-property-lib": "/smart-property-lib/static-1.8251",
  "tiered-pricing": "/tiered-pricing/static-1.1926",
  "topics-actions-lib": "/topics-actions-lib/static-1.446",
  "trial-components-library": "/trial-components-library/static-1.14080",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9359",
  "zustand": "/zustand/static-1.83",
  "final-form": "/final-form/static-1.76",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "rich-text-lib": "/rich-text-lib/static-1.20279",
  "tinymce-themes": "/tinymce-themes/static-1.57039",
  "data-token-picker": "/data-token-picker/static-1.16861",
  "hub-http-contrib": "/hub-http-contrib/static-1.3320",
  "interframe": "/interframe/static-3.5037",
  "tinymce-data": "/tinymce-data/static-1.41154",
  "tinymce-plugins": "/tinymce-plugins/static-1.58183",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5494",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7079",
  "ui-addon-opt": "/ui-addon-opt/static-4.8645",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.618",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.431",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6342",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2482",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2683",
  "user-context-client": "/user-context-client/static-1.4789",
  "idb-keyval": "/idb-keyval/static-1.49",
  "magpie-types": "/magpie-types/static-1.5200",
  "nest": "/nest/static-1.517",
  "reactive-lib": "/reactive-lib/static-1.1001",
  "simple-logging-lib": "/simple-logging-lib/static-1.3332",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1166",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18319",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1683",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14408",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5890",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8059",
  "redux-observable": "/redux-observable/static-1.73",
  "ReduxMessenger": "/ReduxMessenger/static-2.10651",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.884",
  "calling-error-reporting": "/calling-error-reporting/static-1.31606",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11322",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6818",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1990",
  "customer-data-tracking": "/customer-data-tracking/static-1.7163",
  "commerce-permissions": "/commerce-permissions/static-1.1059",
  "products-iframe-lib": "/products-iframe-lib/static-1.8557",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10968",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6723",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10669",
  "sales-views-client-types": "/sales-views-client-types/static-1.4537",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10063",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4431",
  "video-components-external": "/video-components-external/static-1.12121",
  "video-data-lib": "/video-data-lib/static-1.35779",
  "bark-lib": "/bark-lib/static-1.16793",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.100",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6171",
  "react-codemirror": "/react-codemirror/static-1.10920",
  "data-agent-kit": "/data-agent-kit/static-1.622",
  "feedback-loader": "/feedback-loader/static-1.29782",
  "fsm": "/fsm/static-1.4031",
  "policy-lib": "/policy-lib/static-1.7083",
  "react-colorpicker": "/react-colorpicker/static-2.10497",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10732",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15474",
  "hubs-service-types": "/hubs-service-types/static-1.1538",
  "FileManagerLib": "/FileManagerLib/static-1.40086",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9249",
  "FileManagerCore": "/FileManagerCore/static-1.39945",
  "content-assistance-lib": "/content-assistance-lib/static-1.8175",
  "layout-dnd-components": "/layout-dnd-components/static-1.12939",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11914",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10167",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16412",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15525",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7890",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.661",
  "breeze-engine-core": "/breeze-engine-core/static-1.961",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.84",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3289",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.429",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1260",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.995",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.104",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.438",
  "slack-ui-library": "/slack-ui-library/static-1.10681",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36767",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3772",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13198",
  "content-media-compositions": "/content-media-compositions/static-2.17205",
  "media-bridge-lib": "/media-bridge-lib/static-1.19381",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16331",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4790",
  "storybook-react": "/storybook-react/static-1.38",
  "academy-common-lib": "/academy-common-lib/static-1.14934",
  "audio-components": "/audio-components/static-1.6317",
  "FileManagerImages": "/FileManagerImages/static-1.37597",
  "video-components": "/video-components/static-1.14123",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.277",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.59",
  "urlinator": "/urlinator/static-1.4814",
  "video-embed": "/video-embed/static-1.36613",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8984",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29272",
  "ContentData": "/ContentData/static-1.69166",
  "layout-data-lib": "/layout-data-lib/static-1.10239",
  "academy-service-client": "/academy-service-client/static-1.3968",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4684",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7603",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9819",
  "wootric-nps": "/wootric-nps/static-1.7186",
  "social-insights-client-types": "/social-insights-client-types/static-1.22704",
  "outpost": "/outpost/static-1.4438",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6866",
  "advanced-menus-core": "/advanced-menus-core/static-1.15551",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12427",
  "ExportDialog": "/ExportDialog/static-6.10659",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34808",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19225",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20693",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15550",
  "simple-menus-lib": "/simple-menus-lib/static-1.17067",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10786",
  "immutable-less": "/immutable-less/static-1.4931",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18100",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8306",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4199",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8303",
  "nav-meta": "/nav-meta/static-1.30431",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.994",
  "apps-service-types": "/apps-service-types/static-1.4021",
  "oauth-service-types": "/oauth-service-types/static-1.4518",
  "simple-data-table": "/simple-data-table/static-1.3501"
}
};
